'use client';

import { type ReactNode, createContext, useContext, useState } from 'react';
import TradeCollectionList from '../../../features/lottery/components/TradeCollectionList/TradeCollectionList';
import TradeSelectedPrizeList from '../../../features/lottery/components/TradeSelectedPrizeList/TradeSelectedPrizeList';
import type { LotteryTradeMyGoods, TradeDesiredGoods } from '../../../features/lottery/types';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import TradeBar from '../TradeBar/TradeBar';

type TradeContextType = {
  selectedItems: Map<string, number>;
  setSelectedItems: React.Dispatch<React.SetStateAction<Map<string, number>>>;
};

const TradeContext = createContext<TradeContextType | undefined>(undefined);

export function useTradeContext() {
  const context = useContext(TradeContext);
  if (context === undefined) {
    throw new Error('useTradeContext must be used within a TradeProvider');
  }
  return context;
}

export function TradeProvider({ children }: { children: ReactNode }) {
  const [selectedItems, setSelectedItems] = useState<Map<string, number>>(new Map());

  return <TradeContext.Provider value={{ selectedItems, setSelectedItems }}>{children}</TradeContext.Provider>;
}

export type TradePageClientProps = {
  tradeGoodsList: LotteryTradeMyGoods | TradeDesiredGoods;
  lotteryId: string;
  hashKey?: string;
  /** select-desired-prizesページで必要数の表示を有効にする */
  showInsufficientCount?: boolean;
  /** 保有数を表示するかどうか（falseの場合は「獲得済み」を表示） */
  showOwnedCount?: boolean;
  /** 景品一覧のタイトル */
  title?: string;
};

export function TradePageClient({
  tradeGoodsList,
  lotteryId,
  hashKey,
  showInsufficientCount = false,
  showOwnedCount = true,
  title,
}: TradePageClientProps) {
  return (
    <TradeProvider>
      <div className={utilsStyles.tradePageContainer}>
        <TradeCollectionList tradeCollectionGoodsList={tradeGoodsList} showOwnedCount={showOwnedCount} title={title} />
      </div>

      <TradeSelectedPrizeList tradeGoodsList={tradeGoodsList} showInsufficientCount={showInsufficientCount} />

      <TradeBar goods={tradeGoodsList} lotteryId={lotteryId} hashKey={hashKey} />
    </TradeProvider>
  );
}
